import {
  confirmable,
  createConfirmation,
  type ConfirmDialogProps,
} from "react-confirm";

import MultipleChoiceModal from "./MultipleChoiceModal";

type MultipleChoiceConfirmOptions = {
  subtitle?: string;
  description?: string;
  confirmLabel?: string;
  confirmColor?: string;
  cancelLabel?: string;
};

type MultipleChoiceConfirmArgs = {
  confirmation?: string;
  options?: MultipleChoiceConfirmOptions;
};

function MultipleChoiceConfirm({
  show,
  proceed,
  confirmation,
  options = {},
}: ConfirmDialogProps<MultipleChoiceConfirmArgs, boolean>) {
  const {
    subtitle,
    description,
    confirmLabel = "Confirm",
    confirmColor = "red",
    cancelLabel = "Cancel",
  } = options;

  return (
    <MultipleChoiceModal
      open={show}
      closeModal={() => proceed(false)}
      title={confirmation ?? "Are you sure?"}
      subtitle={subtitle ?? description ?? ""}
      options={[
        {
          color: confirmColor,
          label: confirmLabel,
          onClick: () => proceed(true),
        },
        {
          color: "blue",
          label: cancelLabel,
          onClick: () => proceed(false),
        },
      ]}
    />
  );
}

const confirmableModal = confirmable<MultipleChoiceConfirmArgs, boolean>(
  MultipleChoiceConfirm,
);
const confirm = createConfirmation<MultipleChoiceConfirmArgs, boolean>(
  confirmableModal,
);

export function multipleChoiceConfirmWrapper(
  confirmation: string,
  options: MultipleChoiceConfirmOptions = {},
): Promise<boolean> {
  return confirm({ confirmation, options });
}
